import React, { useEffect, useState } from 'react';
import LinkItem from '../../components/link-item';
import useMsalApi from '../../components/use-msal-api';
import { StructuredListSkeleton, StructuredListWrapper, StructuredListHead, Button, StructuredListRow, StructuredListCell } from "carbon-components-react";
import { formatDate } from '../../components/formatters';
import { useNavigate } from 'react-router';
import { EnrollmentType } from '../../components/enums/enrollment-type';

const PendingSubmissions = () => {
    const [submissions, setSubmissions] = useState();
    const [callApi] = useMsalApi();
    const navigate = useNavigate();

    useEffect(() => {
        getSubmissions();
    }, [])

    const getSubmissions = async () => {
        const results = await callApi("Enrollments/SubmittedList", "GET");
        if(!results.error)
            setSubmissions(results);
    }

    const getChangeType = (type, effectiveDate) => {
        const isFuture = new Date() < new Date(effectiveDate);
        switch (type) {
            case EnrollmentType.NewHire:
                if(isFuture)
                    return "Future New Hire";
                return "New Hire";
            case EnrollmentType.OpenEnrollment:
                return "Open Enrollment";
            case EnrollmentType.LifeEvent:
                return "Qualifying Life Event";
            case EnrollmentType.BenficiaryChange:
                return "Beneficiary Change";
            default:
                return "Unknown";
        }
    };


    return ( 
        <>
            <h3>Submitted Enrollments</h3>
            {submissions ? 
                <StructuredListWrapper>
                <StructuredListHead>
                    <StructuredListRow head>
                        <StructuredListCell head>Employee</StructuredListCell>
                        <StructuredListCell head>Type</StructuredListCell>
                       <StructuredListCell head>Effective Date</StructuredListCell>
                        <StructuredListCell head></StructuredListCell>
                   </StructuredListRow>                    
                </StructuredListHead>
                {submissions.map((submission, idx) =>

<StructuredListRow  key={idx}>
<StructuredListCell>{submission.employeeName} <br />
<span className='text-gray-400'>{submission.employeeNumber}</span>
</StructuredListCell>
<StructuredListCell>{getChangeType(submission.enrollmentTypeId, submission.effectiveDate)}</StructuredListCell>
<StructuredListCell>{formatDate(submission.effectiveDate)}</StructuredListCell>
<StructuredListCell>
    <Button size="sm" kind="tertiary" onClick={() => navigate(`/Submission/${submission.id}`)}>Review</Button>
</StructuredListCell>
</StructuredListRow>
                )}
                </StructuredListWrapper> 
                : 
                <><StructuredListSkeleton /></>
            }
        </>
     );
}
 
export default PendingSubmissions;